module.exports = __webpack_public_path__ + "asset/image-arrow-537c8a87f80f99f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/image/arrow.svg
// module id = O0OW
// module chunks = 3